import { useCallback, useEffect, useState } from 'react';
import {
	GEO_LOCATION_PERMISSION_GRANTED,
	GEO_LOCATION_PERMISSION_PROMPT,
} from 'shared/custom/constants/commonConstants';

const ALLOWED_PERMISSION_STATES: string[] = [
	GEO_LOCATION_PERMISSION_GRANTED,
	GEO_LOCATION_PERMISSION_PROMPT,
];

export const useGeolocationStatus = () => {
	const [enableGeolocButton, setEnableGeolocButton] = useState<boolean>(true);
	const [isLoadingGeoLocResponse, setIsLoadingGeoLocResponse] = useState<boolean>(true);

	const validateGeolocationStatus = useCallback(() => {
		if (!navigator?.permissions) {
			setIsLoadingGeoLocResponse(false);
			return;
		}
		navigator.permissions
			.query({ name: 'geolocation' })
			.then((result) => {
				setEnableGeolocButton(ALLOWED_PERMISSION_STATES.includes(result.state));
			})
			.finally(() => {
				setIsLoadingGeoLocResponse(false);
			});
	}, []);

	useEffect(() => {
		validateGeolocationStatus();
	}, [validateGeolocationStatus]);

	return {
		enableGeolocButton,
		isLoadingGeoLocResponse,
		validateGeolocationStatus,
		setEnableGeolocButton,
	};
};
